import crownIcon from '@/commerce/assets/icon-crown.png';

interface DiamondIconProps {
    size?: number;
    className?: string;
}

/** 行内黄钻图标（跟随文字，如 Tab 标题后） */
export function DiamondIcon({size = 14, className}: DiamondIconProps) {
    return (
        <img
            src={crownIcon}
            className={className}
            style={{
                width: size,
                height: size,
                objectFit: 'contain',
                verticalAlign: 'middle',
            }}
            alt=""
            draggable={false}
        />
    );
}
